import type { ID } from '@octopus-do/octopus-project-core'
import { DropdownMenu } from '@octopus-do/octopus-storybook'
import type React from 'react'

import { FolderMenuContent } from './components'

interface Props extends React.PropsWithChildren {
  id: ID
  title: string
  disabledMoveUp: boolean
  disabledMoveDown: boolean
  showAccess: boolean
  onClick: (keys: string[]) => void
}

export const FolderMenu: React.FC<Props> = ({
  id,
  title,
  disabledMoveUp,
  disabledMoveDown,
  children,
  onClick,
  showAccess,
}) => {
  const handleMenuItemClick = (keys: string[]) => onClick([...keys, id, title])

  return (
    <DropdownMenu.Root
      align="center"
      content={FolderMenuContent}
      disabledMoveUp={disabledMoveUp}
      disabledMoveDown={disabledMoveDown}
      showAccess={showAccess}
      onClick={handleMenuItemClick}
    >
      {children}
    </DropdownMenu.Root>
  )
}
